import questionMark from '../images/question-mark-mobile.svg'
import closeIcon from '../images/close-icon-mobile.svg'

type MobileScreen1Props = {
  onClose: () => void
}

const MobileScreen1 = ({ onClose }: MobileScreen1Props) => {
  return (
    <div
      className="flex flex-col items-center justify-center w-full h-full gap-8 text-center bg-[#222222] opacity-[.95]"
      style={{
        backdropFilter: 'blur(11px)',
      }}
    >
      <img
        src={closeIcon}
        alt="letter x"
        className="absolute top-0 right-0 p-8"
        role="button"
        onClick={onClose}
      />
      <p className="text-white font-decimal text-[26px] uppercase font-bold px-4">
        Click on this icon on any page to switch to helper view
      </p>
      <img src={questionMark} alt="question mark" />
    </div>
  )
}
export default MobileScreen1
